// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__nmiqR","jpCurrentDate":"JP_Footer_jpCurrentDate__PCB8R","jpFootage":"JP_Footer_jpFootage__O2-mT","higlight":"JP_Footer_higlight__DqvnN"};